module.exports = "/_next/static/images/fee_optimization_desktop-8df00587945021f45e27032c16dbb58c.jpg";